<template>
  <div id="inspire" class="dashboard-container">
    <!-- Pantalla de Carga -->
    <div v-if="propLoading" class="loading-overlay">
      <div class="v-spinner">
        <div class="v-sync v-sync1" :style="spinnerStyle"></div>
        <div class="v-sync v-sync2" :style="spinnerStyle"></div>
        <div class="v-sync v-sync3" :style="spinnerStyle"></div>
      </div>
    </div>

    <div v-else class="dashboard-layout">
      <!-- Barra Superior -->
      <v-app-bar app flat class="dashboard-toolbar" color="white">
        <v-toolbar-title class="brand-title">
          <span class="text-primary font-weight-bold">PREMIOS</span>
          <span class="text-secondary ml-1">ADMIN</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn outlined color="#294697" class="mr-4 top-button" @click="dialogTope = true">
          <v-icon left>mdi-account-cog-outline</v-icon>
          CONFIGURAR TOPE
        </v-btn>
        <v-btn text color="#294697" @click="logout" class="logout-btn">
          <span class="mr-2">SALIR</span>
          <v-icon small>mdi-logout-variant</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Barra Lateral -->
      <v-navigation-drawer
        v-model="drawer"
        app
        permanent
        class="dashboard-drawer"
        width="260"
      >
        <div class="drawer-header">
          <v-img
            :src="require('../../../assets/nova/NOMBREBLANCO.png')"
            max-height="60"
            contain
            class="ma-4"
          ></v-img>
        </div>

        <v-divider class="mx-4 mb-4" dark style="opacity: 0.1"></v-divider>

        <div class="user-profile px-4 py-6">
          <v-avatar color="rgba(255,255,255,0.1)" size="64" class="mb-3">
            <v-icon dark size="40">mdi-account-circle</v-icon>
          </v-avatar>
          <div class="user-name">{{ nombre }}</div>
          <div class="user-role">{{ rol }}</div>
        </div>

        <v-list nav dense class="mt-4">
          <v-list-item-group color="white">
            <v-list-item to="/Premios/Admin" exact active-class="active-item">
              <v-list-item-icon>
                <v-icon color="white">mdi-view-dashboard</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">Inicio</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item @click="abrirHistorial" class="menu-item" active-class="active-item">
              <v-list-item-icon>
                <v-icon color="white">mdi-account-question-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="white--text">Historial de consultas</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>

        <template v-slot:append>
          <div class="pa-4 drawer-footer d-flex align-center justify-center">
            <v-img
                :src="require('../../../assets/LOGO-FACILISIMO-GRIS.png')"
                contain
                max-height="30"
                max-width="120"
                class="mr-2"
                style="filter: brightness(0) invert(1); opacity: 0.5"
            ></v-img>

            <v-img
                :src="require('../../../assets/nova/LOGO APOSTAR-06.png')"
                contain
                max-height="30"
                max-width="120"
                style="filter: brightness(0) invert(1); opacity: 0.5"
            ></v-img>
          </div>
        </template>
      </v-navigation-drawer>

      <!-- Contenido Principal -->
      <v-main class="dashboard-main">
        <v-container fluid fill-height class="pa-6 content-container">
          <v-fade-transition mode="out-in">
            <router-view />
          </v-fade-transition>
        </v-container>
      </v-main>
    </div>

    <v-dialog v-model="dialogTope" max-width="460" persistent :retain-focus="false">
      <v-card class="limit-dialog">
        <v-card-title class="dialog-title">
          <div class="dialog-title-content">
            <v-icon color="#294697" class="mr-3">mdi-account-cog-outline</v-icon>
            <span>Configurar tope por usuario</span>
          </div>
          <v-btn icon class="dialog-close-btn" @click="closeDialog" :disabled="savingTope">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <v-form ref="topeForm" v-model="formValid" @submit.prevent="saveTope">
            <v-text-field
              v-model.trim="form.cedula"
              label="Cédula del usuario"
              placeholder="Ej. 1234567890"
              outlined
              type="number"
              min="1"
              prepend-inner-icon="mdi-card-account-details-outline"
              :rules="cedulaRules"
              :disabled="savingTope"
              required
            ></v-text-field>

            <v-alert v-if="searchingUser" type="info" text dense>
              Buscando usuario...
            </v-alert>
            <v-alert v-else-if="userMessage" :type="userFound ? 'success' : 'error'" text dense>
              {{ userMessage }}
            </v-alert>

            <v-text-field
              v-if="userFound"
              :value="form.nombre"
              label="Nombre del usuario"
              outlined
              readonly
              prepend-inner-icon="mdi-account-check-outline"
            ></v-text-field>

            <v-text-field
              v-if="userFound"
              :value="topeFormateado"
              label="Tope configurado actualmente"
              outlined
              readonly
              prepend-inner-icon="mdi-cash-check"
            ></v-text-field>

            <v-select
              v-model="form.tope_premio"
              label="Tope del premio"
              outlined
              :items="topesDisponibles"
              item-text="label"
              item-value="value"
              prepend-inner-icon="mdi-cash-multiple"
              :rules="[value => !!value || 'Selecciona un tope']"
              :disabled="savingTope"
              required
            ></v-select>
          </v-form>
        </v-card-text>

        <v-card-actions class="dialog-actions px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" class="cancel-btn" @click="closeDialog" :disabled="savingTope">
            CANCELAR
          </v-btn>
          <v-btn color="#294697" dark :loading="savingTope" :disabled="!formValid" class="save-btn" @click="saveTope">
            <v-icon left>mdi-content-save-outline</v-icon>
            GUARDAR TOPE
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Modal / Alerta simplificada para consultar historial por usuario -->
    <v-dialog v-model="dialogHistorial" max-width="680" persistent :retain-focus="false">
      <v-card class="limit-dialog">
        <v-card-title class="dialog-title">
          <div class="dialog-title-content">
            <v-icon color="#294697" class="mr-3">mdi-account-question-outline</v-icon>
            <span>Historial de consultas (Últimas 15)</span>
          </div>
          <v-btn icon class="dialog-close-btn" @click="cerrarHistorialDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <!-- Buscador ÚNICO: por nombre o cédula del usuario -->
          <v-text-field
            v-model.trim="busquedaHistorial"
            label="Buscar por cédula o nombre del usuario"
            placeholder="Ej. 1010112750 o Juan Diego..."
            outlined
            dense
            clearable
            prepend-inner-icon="mdi-account-search-outline"
            color="#294697"
            @keyup.enter="consultarHistorialUsuario"
            @click:clear="limpiarHistorial"
            class="mb-3"
            hide-details
          ></v-text-field>

          <v-btn
            block
            color="#294697"
            dark
            class="mb-4"
            height="44"
            :loading="cargandoHistorial"
            @click="consultarHistorialUsuario"
          >
            <v-icon left>mdi-magnify</v-icon>
            BUSCAR CONSULTAS
          </v-btn>

          <!-- Estado inicial -->
          <v-alert
            v-if="!historialBuscado"
            type="info"
            text
            dense
            icon="mdi-information-outline"
            class="mb-0"
          >
            Ingresa el nombre o la cédula de un usuario para consultar sus últimas 15 colillas revisadas o impresas.
          </v-alert>

          <!-- Sin resultados -->
          <v-alert
            v-else-if="historialItems.length === 0"
            type="warning"
            text
            dense
            icon="mdi-alert-circle-outline"
            class="mb-0"
          >
            No se encontraron consultas registradas para este usuario.
          </v-alert>

          <!-- Lista limpia de resultados (sin saturación técnica) -->
          <div v-else class="historial-lista-container" style="max-height: 380px; overflow-y: auto;">
            <div
              v-for="item in historialItems"
              :key="item.id"
              class="historial-card pa-3 mb-2 rounded-lg"
              style="border: 1px solid #e2e8f0; background: #f8fafc;"
            >
              <div class="d-flex align-center justify-space-between mb-1">
                <div>
                  <span class="font-weight-bold primary--text">{{ item.usuario_nombre }}</span>
                  <span class="text-caption grey--text ml-2">C.C. {{ item.usuario_identificacion }}</span>
                </div>
                <v-chip
                  x-small
                  :color="item.tipo_accion === 'IMPRESION' ? 'teal lighten-5' : 'indigo lighten-5'"
                  :text-color="item.tipo_accion === 'IMPRESION' ? 'teal darken-3' : 'indigo darken-3'"
                  class="font-weight-bold"
                >
                  <v-icon left x-small>{{ item.tipo_accion === 'IMPRESION' ? 'mdi-printer' : 'mdi-magnify' }}</v-icon>
                  {{ item.tipo_accion }}
                </v-chip>
              </div>

              <div class="d-flex align-center justify-space-between text-body-2 mb-1">
                <div>
                  <span class="grey--text text--darken-1">Colilla:</span>
                  <span class="font-weight-bold ml-1">{{ item.colilla_referencia }}</span>
                </div>
                <div v-if="item.valor_premio">
                  <span class="grey--text text--darken-1">Valor:</span>
                  <span class="font-weight-bold green--text text--darken-2 ml-1">
                    {{ formatearMoneda(item.valor_premio) }}
                  </span>
                </div>
              </div>

              <div class="d-flex align-center justify-space-between text-caption grey--text text--darken-1">
                <div>
                  <v-icon x-small class="mr-1">mdi-clock-outline</v-icon>
                  {{ formatearFechaSimple(item.fecha_hora) }}
                </div>
                <v-chip x-small :color="colorChipResultado(item.resultado).bg" :text-color="colorChipResultado(item.resultado).text">
                  {{ item.resultado }}
                </v-chip>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="px-6 py-3 bg-light">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-2" @click="cerrarHistorialDialog">
            CERRAR
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import env from "../../env";
import Swal from "sweetalert2";

export default {
  name: 'DashboardAdmin',
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#294697'
    },
    size: {
      type: String,
      default: '15px'
    }
  },
  data() {
    return {
      propLoading: true,
      nombre: localStorage.getItem("nombre"),
      rol: localStorage.getItem("rol"),
      drawer: true,
      dialogTope: false,
      savingTope: false,
      dialogHistorial: false,
      cargandoHistorial: false,
      historialBuscado: false,
      busquedaHistorial: "",
      historialItems: [],
      searchingUser: false,
      userFound: false,
      userMessage: "",
      searchTimer: null,
      formValid: false,
      form: {
        cedula: "",
        id_usuario: "",
        nombre: "",
        tope_premio: null
      },
      topesDisponibles: [
        { label: "$5.000.000", value: "5000000" },
        { label: "$10.000.000", value: "10000000" }
      ],
      cedulaRules: [
        value => !!value || "Ingresa la cédula",
        value => /^\d+$/.test(String(value)) || "La cédula solo debe contener números"
      ],
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: '2px',
        borderRadius: '100%',
        display: 'inline-block',
        animation: 'v-syncStretchDelay 0.6s infinite ease-in-out both'
      }
    }
  },
  methods: {
    logout() {
      this.$router.push("/");
    },
    closeDialog() {
      if (this.savingTope) return;
      clearTimeout(this.searchTimer);
      this.dialogTope = false;
      this.$nextTick(() => {
        this.form = { cedula: "", id_usuario: "", nombre: "", tope_premio: null };
        this.userFound = false;
        this.userMessage = "";
        if (this.$refs.topeForm) this.$refs.topeForm.resetValidation();
      });
    },
    async searchUser() {
      const cedula = String(this.form.cedula || "").trim();
      this.form.id_usuario = "";
      this.form.nombre = "";
      this.form.tope_premio = null;
      this.userFound = false;
      this.userMessage = "";

      if (!/^\d{4,}$/.test(cedula)) return;

      this.searchingUser = true;
      try {
        const response = await axios.get(`${env.endpoint}premios/buscar_usuario_tope`, {
          params: { cedula },
          timeout: 10000
        });
        const usuario = response.data.usuario;
        if (cedula !== String(this.form.cedula || "").trim()) return;

        this.form.id_usuario = String(usuario.idUsuario);
        this.form.nombre = usuario.nombre;
        this.form.tope_premio = usuario.tope_premio || null;
        this.userFound = true;
        this.userMessage = "Usuario encontrado";
      } catch (error) {
        this.userFound = false;
        this.userMessage = error.response?.data?.mensaje || "No existe un usuario con esa cédula.";
      } finally {
        this.searchingUser = false;
      }
    },
    async saveTope() {
      if (!this.$refs.topeForm.validate()) return;
      if (!this.userFound || !this.form.id_usuario) return;

      this.savingTope = true;
      try {
        const response = await axios.post(`${env.endpoint}premios/guardar_tope`, {
          id_usuario: this.form.id_usuario,
          tope_premio: this.form.tope_premio
        }, {
          timeout: 15000
        });

        if (response.data.status !== true && response.data.status !== "true") {
          throw new Error(response.data.mensaje || "No se pudo guardar el tope.");
        }

        this.savingTope = false;
        this.closeDialog();
        await Swal.fire({
          icon: "success",
          title: "Tope guardado",
          text: response.data.mensaje || "El tope del usuario fue actualizado.",
          confirmButtonColor: "#294697"
        });
      } catch (error) {
        this.savingTope = false;
        this.closeDialog();
        Swal.fire({
          icon: "error",
          title: "No se pudo guardar",
          text: error.response?.data?.mensaje || error.message || "Intenta de nuevo.",
          confirmButtonColor: "#294697"
        });
      } finally {
        this.savingTope = false;
      }
    },
    abrirHistorial() {
      this.dialogHistorial = true;
      if (this.busquedaHistorial && this.busquedaHistorial.trim()) {
        this.consultarHistorialUsuario();
      }
    },
    cerrarHistorialDialog() {
      this.dialogHistorial = false;
    },
    limpiarHistorial() {
      this.busquedaHistorial = "";
      this.historialItems = [];
      this.historialBuscado = false;
    },
    async consultarHistorialUsuario() {
      if (!this.busquedaHistorial || !this.busquedaHistorial.trim()) {
        Swal.fire({
          icon: "info",
          title: "Atención",
          text: "Ingresa el nombre o la cédula del usuario para buscar.",
          confirmButtonColor: "#294697"
        });
        return;
      }

      this.cargandoHistorial = true;
      this.historialBuscado = true;
      try {
        const idUsuarioAdmin = localStorage.getItem("id");
        const params = new URLSearchParams({
          id_usuario: idUsuarioAdmin != null ? String(idUsuarioAdmin) : "",
          usuario: this.busquedaHistorial.trim(),
          limit: "15"
        });

        const response = await axios.get(`${env.endpoint}premios/historial?${params.toString()}`);
        if (response.data && response.data.status) {
          this.historialItems = response.data.items || [];
        } else {
          this.historialItems = [];
        }
      } catch (error) {
        console.error("Error al consultar historial:", error);
        this.historialItems = [];
      } finally {
        this.cargandoHistorial = false;
      }
    },
    formatearFechaSimple(fechaStr) {
      if (!fechaStr) return "-";
      const fecha = new Date(fechaStr.replace(/-/g, "/"));
      if (isNaN(fecha.getTime())) return fechaStr;
      return fecha.toLocaleString("es-CO", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    formatearMoneda(val) {
      return new Intl.NumberFormat("es-CO", {
        style: "currency",
        currency: "COP",
        maximumFractionDigits: 0
      }).format(val);
    },
    colorChipResultado(resultado) {
      switch (resultado) {
        case "EXITOSA":
          return { bg: "green lighten-5", text: "green darken-3" };
        case "NO_ENCONTRADA":
          return { bg: "red lighten-5", text: "red darken-3" };
        case "OFICINA_PRINCIPAL":
          return { bg: "amber lighten-5", text: "amber darken-4" };
        case "PAGADO":
          return { bg: "blue lighten-5", text: "blue darken-3" };
        default:
          return { bg: "grey lighten-3", text: "grey darken-3" };
      }
    }
  },
  computed: {
    topeFormateado() {
      if (!this.form.tope_premio) return "Sin tope configurado";
      return `$${Number(this.form.tope_premio).toLocaleString("es-CO")}`;
    }
  },
  watch: {
    "form.cedula"() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => this.searchUser(), 350);
    }
  },
  mounted() {
    setTimeout(() => {
      this.propLoading = false;
    }, 800);
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&family=Source+Sans+Pro:wght@400;600&display=swap');

.dashboard-container {
  font-family: 'Source Sans Pro', sans-serif;
  background-color: #f4f7f9;
  min-height: 100vh;
}

.loading-overlay {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
}

.dashboard-layout {
  display: flex;
  flex-direction: column;
}

.dashboard-toolbar {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.brand-title {
  font-family: 'Poppins', sans-serif;
  font-size: 1.2rem;
  letter-spacing: 1px;
}

.text-primary {
  color: #294697;
}

.text-secondary {
  color: #64748b;
}

.dashboard-drawer {
  background: linear-gradient(180deg, #1D3C7F 0%, #112552 100%) !important;
  border: none !important;
}

.drawer-header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.user-name {
  color: white;
  font-weight: 600;
  font-size: 1.1rem;
  font-family: 'Poppins', sans-serif;
}

.user-role {
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 4px;
}

.active-item {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px !important;
}

.dashboard-main {
  background-color: #f4f7f9;
  padding: 0 !important;
}

.logout-btn {
  font-weight: 600;
  letter-spacing: 1px;
}

.top-button {
  font-weight: 600;
  letter-spacing: 0.4px;
}

.limit-dialog {
  border-radius: 18px !important;
  overflow: hidden !important;
  box-shadow: 0 18px 40px rgba(15, 23, 42, 0.12) !important;
  border: 1px solid rgba(148, 163, 184, 0.2);
}

.dialog-title {
  color: #1f2937;
  font-family: 'Poppins', sans-serif;
  font-size: 1.75rem !important;
  font-weight: 800 !important;
  letter-spacing: -0.04em;
  line-height: 1.15 !important;
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 20px 14px !important;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}

.dialog-title-content {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  gap: 10px;
  overflow: hidden;
}

.dialog-title-content span {
  display: block;
  flex: 1;
  min-width: 0;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
  line-height: 1.2;
}

.dialog-close-btn {
  width: 42px !important;
  height: 42px !important;
  min-width: 42px !important;
  border-radius: 12px !important;
  background: rgba(148, 163, 184, 0.12) !important;
  color: #475569 !important;
  margin-left: 8px;
}

.dialog-close-btn:hover {
  background: rgba(41, 70, 151, 0.08) !important;
}

.v-card__text {
  padding-top: 18px !important;
}

.v-text-field--outlined >>> .v-input__slot,
.v-select--outlined >>> .v-input__slot {
  min-height: 58px !important;
  border-radius: 12px !important;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: inset 0 0 0 1px rgba(148, 163, 184, 0.35);
}

.v-text-field--outlined >>> .v-input__slot:hover,
.v-select--outlined >>> .v-input__slot:hover {
  box-shadow: inset 0 0 0 1px rgba(41, 70, 151, 0.4);
}

.v-text-field--outlined >>> .v-label,
.v-select--outlined >>> .v-label {
  font-size: 1rem;
  color: #64748b;
}

.v-alert {
  border-radius: 10px !important;
  margin-bottom: 10px;
}

.dialog-actions {
  padding-top: 8px !important;
  padding-bottom: 20px !important;
}

.cancel-btn {
  min-width: 150px !important;
  height: 52px !important;
  font-weight: 700 !important;
  letter-spacing: 0.08em;
  border-radius: 12px !important;
  background: #f3f4f6 !important;
  color: #374151 !important;
  box-shadow: none !important;
}

.save-btn {
  min-width: 190px !important;
  height: 52px !important;
  border-radius: 12px !important;
  font-weight: 700 !important;
  letter-spacing: 0.04em;
  background: linear-gradient(135deg, #294697 0%, #1d3c7f 100%) !important;
  box-shadow: 0 10px 18px rgba(41, 70, 151, 0.18) !important;
}

@keyframes v-syncStretchDelay {
  33% { transform: translateY(10px); }
  66% { transform: translateY(-10px); }
  100% { transform: translateY(0); }
}

.v-sync1 { animation-delay: 0.07s !important; }
.v-sync2 { animation-delay: 0.14s !important; }
.v-sync3 { animation-delay: 0.21s !important; }
</style>
